<template>
  <div>
    <b-modal size="lg" no-close-on-backdrop hide-header-close v-model="state"
      title="Relatório de pagamento de comissão">
      <b-row>
        <b-col>
          <b-form-group>
            <b-form-radio-group v-model="tipoUsuario" :options="optionsTipoUser" plain></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="tipoUsuario == 'P'">
        <b-col>
          <label for="">Preposto</label>
          <b-form-select :options="prepostos" v-model="preposto"></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="tipoUsuario == 'R'">
        <b-col>
          <label for="">Representante</label>
          <b-form-select :options="representantes" v-model="representante"></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="tipoUsuario == 'G'">
        <b-col>
          <label for="">Gerente</label>
          <b-form-select :options="gerentes" v-model="gerente"></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="tipoUsuario == 'G'" class="mt-3">
        <b-col>
          <label for="">Porcentagem %</label>
          <b-form-input v-mask="['#', '#.#', '#.##', '##.##']" v-model="porcentagem" placeholder="3.00"></b-form-input>
        </b-col>
      </b-row>
      <!-- <b-row class="mt-3">
        <b-col>
          <label for="">Tipo</label>
          <b-form-select :options="optionsTipo" v-model="tipo"></b-form-select>
        </b-col>
      </b-row> -->
      <b-row v-if="tipo == 'COMISSAO'" class="mt-3">
        <b-col>
          <label for="">Mês</label>
          <b-form-select :options="optionsMes" v-model="mes"></b-form-select>
        </b-col>
        <b-col>
          <label for="">Ano</label>
          <b-form-select :options="optionsAno" v-model="ano"></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="tipo == 'COMISSAO'" class="mt-3">
        <b-col>
          <label for="">Status dos Titulos</label>
          <b-form-select :options="optionsStatus" v-model="status"></b-form-select>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div>
          <b-button :disabled="loadAtt || loading" size="sm" variant="success" @click="gerarRelatorio('PDF')">
            <i v-if="!loadAtt || !loading" class="fas fa-chart-bar"></i>
            <b-spinner v-else small></b-spinner>
            Gerar
          </b-button>

          <b-button :disabled="loading" size="sm" variant="warning" @click="gerarRelatorio('XLSX')">
            <i v-if="!loadAtt || !loading" class="fas fa-file-excel"></i>
            <b-spinner v-else small></b-spinner>
            Exportar
          </b-button>

          <b-button :disabled="loading" size="sm" variant="danger" @click="statusModal">Fechar</b-button>

        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "relatorio-varejo",
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // downloadexcel,
  },

  data() {
    return {
      optionsTipoUser: [
        { text: 'Gerente', value: 'G' },
        { text: 'Representante', value: 'R' },
        { text: 'Preposto', value: 'P' },
      ],
      loading: false,
      tipoUsuario: 'R',
      porcentagem: null,
      params: {},
      loadAtt: false,
      mes: '01',
      ano: '2023',
      gerentes: [],
      gerente: null,
      representante: null,
      representantes: [],
      preposto: null,
      prepostos: [],
      tipo: 'COMISSAO',
      optionsTipo: ['COMISSAO'],//, 'INCENTIVO'],
      optionsStatus: [
        {
          value: 'aberto', text: 'Aberto'
        },
        {
          value: 'baixado', text: 'Baixado'
        }
      ],
      status: 'aberto',
      optionsMes: [
        {
          value: '01',
          text: 'Janeiro',
        },
        {
          value: '02',
          text: 'Fevereiro'
        },
        {
          value: '03',
          text: 'Março'
        },
        {
          value: '04',
          text: 'Abril'
        },
        {
          value: '05',
          text: 'Maio'
        },
        {
          value: '06',
          text: 'Junho'
        },
        {
          value: '07',
          text: 'Julho'
        },
        {
          value: '08',
          text: 'Agosto'
        },
        {
          value: '09',
          text: 'Setembro'
        },
        {
          value: '10',
          text: 'Outubro'
        },
        {
          value: '11',
          text: 'Novembro'
        },
        {
          value: '12',
          text: 'Dezembro'
        },
      ],
      optionsAno: ['2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035']
    }
  },
  watch: {
    state() {
      //this.$emit('update-modal', !this.state);
    },
    tipoUsuario() {
      this.porcentagem = null
      this.representante = null
    }
  },
  methods: {
    exportarExcel() {
      const vm = this;
      vm.loading = true;
      const data = {
        tipoUsuario: vm.tipoUsuario,
        mes: vm.mes,
        ano: vm.ano,
        representante: vm.representante,
        status: vm.status,
        porcentagem: vm.porcentagem
      }

      axios
        .get('/adm/relatorio/exportar/excel', { params: data })
        .then((response) => {
          console.log(response);
        }).catch((erro) => {
          console.log(erro)
        }).finally(() => {
          vm.loading = false;
        })


    },
    statusModal() {
      this.$emit('update-modal', !this.state);
    },

    gerarRelatorio(tipo) {
      const vm = this;
      if (this.tipoUsuario == 'R' && !this.representante) {
        return vm.$swal({
          title: "Atenção!",
          text: "O representante deve ser selecionado!",
          icon: "warning",
        })
      } else if (this.tipoUsuario == 'G' && !this.porcentagem) {
        return vm.$swal({
          title: "Atenção!",
          text: "Informe a porcentagem de comissão do gerente!",
          icon: "warning",
        })
      }
      if (this.tipoUsuario == 'G' && parseFloat(this.porcentagem) > 3) {
        return vm.$swal({
          title: "Atenção!",
          text: "A comissão  não pode ser maior que 3%",
          icon: "warning",
        })
      }




      this.loading = true

      // if (tipo === 'PDF') {
      if (this.tipoUsuario == 'R') {
        const codigo = tipo + '-' + this.tipoUsuario + '-' + this.mes + '-' + this.ano + '-' + this.representante + '-' + this.status;
        window.open('/adm/relatorio/varejo/' + codigo, "_blank");
      } else if (this.tipoUsuario == 'G') {
        const codigo = tipo + '-' + this.tipoUsuario + '-' + this.mes + '-' + this.ano + '-' + this.gerente + '-' + this.status + '-' + this.porcentagem;
        window.open('/adm/relatorio/varejo/' + codigo, "_blank");
      } else if (this.tipoUsuario == 'P') {
        const codigo = tipo + '-' + this.tipoUsuario + '-' + this.mes + '-' + this.ano + '-' + this.preposto + '-' + this.status;
        window.open('/adm/relatorio/varejo/' + codigo, "_blank");
      }
      this.loading = false;
    },

    getRepresentantes() {
      const vm = this;
      let arrP = [{
        text: 'Selecione o preposto',
        value: null
      }]
      let arrG = [{
        text: 'Selecione o gerente',
        value: null
      }]
      let arr = [{
        text: 'Selecione o representante',
        value: null
      }];
      axios
        .get("/adm/users/representantes")
        .then((response) => {
          response.data.forEach((el) => {
            if (el.preposto) {
              arrP.push({
                text: el.codigo + ' - ' + el.nome,
                value: el.codigo
              })
            }
            if (el.representante) {
              arr.push({
                text: el.codigo + ' - ' + el.nome,
                value: el.codigo
              })
            }
            if (el.gerente) {
              arrG.push({
                text: el.codigo + ' - ' + el.nome,
                value: el.codigo
              })
            }
          })
          vm.representantes = arr;
          vm.gerentes = arrG
          vm.prepostos = arrP
        }).catch((erro) => {
          console.log(erro);
        })
    },
  },
  mounted() {
    this.getRepresentantes();
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/relatorios/componentes/relatorio-varejo.vue